var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.58,
    height: 30.58,
    rx: 6.75,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8151 15.4998H15.9089M12.8151 17.9748H15.9089M12.8151 20.4498H15.9089M18.3839 21.0686H20.2401C20.7324 21.0686 21.2046 20.873 21.5527 20.5249C21.9008 20.1768 22.0964 19.7046 22.0964 19.2123V10.6389C22.0964 9.70253 21.3993 8.90805 20.4662 8.8305C20.1576 8.80492 19.8488 8.78291 19.5397 8.7645M19.5397 8.7645C19.5945 8.94195 19.6214 9.12661 19.6214 9.3123C19.6214 9.47641 19.5562 9.63379 19.4402 9.74983C19.3241 9.86587 19.1667 9.93105 19.0026 9.93105H15.2901C14.9486 9.93105 14.6714 9.65385 14.6714 9.3123C14.6714 9.12173 14.7003 8.93775 14.7539 8.7645M19.5397 8.7645C19.3062 8.00715 18.6 7.45605 17.7651 7.45605H16.5276C16.131 7.45615 15.7448 7.58322 15.4257 7.81867C15.1065 8.05413 14.8711 8.38558 14.7539 8.7645M14.7539 8.7645C14.4437 8.78348 14.1351 8.80575 13.8266 8.8305C12.8935 8.90805 12.1964 9.70253 12.1964 10.6389V12.4061M12.1964 12.4061H9.41201C8.89969 12.4061 8.48389 12.8219 8.48389 13.3342V22.6154C8.48389 23.1278 8.89969 23.5436 9.41201 23.5436H17.4558C17.9681 23.5436 18.3839 23.1278 18.3839 22.6154V13.3342C18.3839 12.8219 17.9681 12.4061 17.4558 12.4061H12.1964ZM10.9589 15.4998H10.9655V15.5064H10.9589V15.4998ZM10.9589 17.9748H10.9655V17.9814H10.9589V17.9748ZM10.9589 20.4498H10.9655V20.4564H10.9589V20.4498Z",
    stroke: "#909090",
    strokeWidth: 1.23731,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay);
export default __webpack_public_path__ + "static/media/Overlay.137d591d3c3c2083f838c59a5c363a1a.svg";
export { ForwardRef as ReactComponent };